import sanitizations from '../sanitizations'

export const create = (payload) => ({
  // eslint-disable-next-line no-undef
  source: payload.source || process.env.VUE_APP_SOURCE,
  type_bond: payload.type_bond,
  name: sanitizations.breakFullName(payload.fullName)[0],
  last_name: sanitizations.breakFullName(payload.fullName)[1],
  cpf: payload.cpf,
  password: payload.cpf,
  rg: payload.identity,
  rg_emissor_org: payload.identityAgency,
  rg_uf: payload.identityUf,
  date_birth: sanitizations.datePayloadPattern(payload.birth),
  email: payload.email,
  phone: payload.phone,
  cellphone: payload.cellphone,
  victmology: payload.victmology,
  is_tracked: payload.tracked || false,
  cnh: {
    place: payload.location,
    uf: payload.cnhUf,
    register: payload.register,
    issuance_date: sanitizations.datePayloadPattern(payload.issuance),
    first_habilitation: sanitizations.datePayloadPattern(payload.firstLicense),
    category: payload.category,
    validate_date: sanitizations.datePayloadPattern(payload.validate),
    image: payload.image,
    image_verse: payload.driverImage,
    father_name: payload.fatherName,
    mother_name: payload.motherName,
    notes: payload.notes,
    safety: payload.security,
    acc: payload.acc,
    renach: payload.renach,
    number: payload.number
  },
})

export const edit = (payload) => ({ ...payload })

export const search = (payload) => {
  const { search, dates, status, preference_region } = payload

  if (!search && !dates && !status && !preference_region) return ``

  const query = {
    status:
      status.length > 0
        ? `${payload.status.map((item) =>
          item !== `in_delivery` && item !== `fidelizados`
            ? `&status=${item}`
            : ``
        )}`.replace(/,/g, ``)
        : ``,
    favorite: status.includes(`fidelizados`) ? `&favorite=true` : ``,
    inDelivery: status.includes(`in_delivery`) ? `&in_delivery=true` : ``,
    dates:
      dates.length > 0
        ? `&initial_date=${sanitizations.dateQueryPattern(dates[0]) ||
        ``}&final_date=${sanitizations.dateQueryPattern(dates[1]) || ``}`
        : ``,
    search: search ? `&search=${payload.search}` : ``,
    preference: preference_region.length ? `&uf=${preference_region.join()}` : ``
  }
  return `${query.status}${query.favorite}${query.inDelivery}${query.dates}${query.search}${query.preference}`
}
